'use strict';

// DEV-18109: "Stored phone numbers" dropdown for the PAF phone field.
// The PAF injects feature fields as raw HTML through the get_features ajax
// endpoint (no ycomponent assets pipeline), so paf.js instantiates this class
// explicitly after injection; the component id is deterministic
// (phonestoreddropdown_paf).

export class Phonestoreddropdown {
	constructor(component_key) {
		this.id = component_key;
		this.$root = jQuery(`.js-${this.id}`);
		this.$input = this.$root.find('.js-phonestoreddropdown_input');
		this.$arrow = this.$root.find('.js-phonestoreddropdown_arrow');
		this.$list = this.$root.find('.js-phonestoreddropdown_list');
	}

	init() {
		if (!this.$root.length) {
			return;
		}
		this.$input.on('focus', () => {
			this.open();
		});
		this.$arrow.on('click', (e) => {
			e.stopPropagation();
			this.toggle();
		});
		this.$list.on('click', '.js-phonestoreddropdown_option', (e) => {
			this.select(jQuery(e.currentTarget));
		});
		jQuery(document).off('click.' + this.id).on('click.' + this.id, (e) => {
			if (!jQuery(e.target).closest(this.$root).length) {
				this.close();
			}
		});
		jQuery(document).off('focusin.' + this.id).on('focusin.' + this.id, (e) => {
			if (!jQuery(e.target).closest(this.$root).length) {
				this.close();
			}
		});
	}

	toggle() {
		if (this.$list.hasClass('hidden')) {
			this.open();
		} else {
			this.close();
		}
	}

	open() {
		yalwa.basics.show(this.$list);
		this.$root.addClass('phonestoreddropdown--open');
		this.$arrow.attr('aria-expanded', 'true');
	}

	close() {
		yalwa.basics.hide(this.$list);
		this.$root.removeClass('phonestoreddropdown--open');
		this.$arrow.attr('aria-expanded', 'false');
	}

	select($option) {
		const value = String($option.data('value'));
		this.$input.val(value);
		// Native bubbling events: paf.js writes the posting state from its
		// 'change' delegate — jQuery's synthetic trigger does not reliably
		// reach it, and the picked number was lost on save (DEV-18109)
		this.$input[0].dispatchEvent(new Event('input', {bubbles: true}));
		this.$input[0].dispatchEvent(new Event('change', {bubbles: true}));
		this.$list.find('.js-phonestoreddropdown_option').removeClass('phonestoreddropdown__list_option--selected');
		$option.addClass('phonestoreddropdown__list_option--selected');
		this.close();
	}
}
